/* gallery-preload.js — 2026-07-06
   Gallery slides 2..N are loading="lazy" and display:none while hidden, so the
   browser fetches each photo only when its thumb is clicked. Preload them all
   during idle time after page load so switching photos is instant. */
(function () {
  var started = false;
  function preload() {
    if (started) return;
    started = true;
    var imgs = document.querySelectorAll('[data-product-media-list] .product__slide img[loading="lazy"]');
    var queue = Array.prototype.slice.call(imgs);
    var active = 0;
    function next() {
      active--;
      pump();
    }
    function pump() {
      while (active < 2 && queue.length) {
        var img = queue.shift();
        var srcset = img.getAttribute('srcset');
        var src = img.getAttribute('src');
        if (!srcset && !src) continue;
        active++;
        var pre = new Image();
        pre.onload = next;
        pre.onerror = next;
        var sizes = img.getAttribute('sizes');
        if (sizes) pre.sizes = sizes;
        if (srcset) pre.srcset = srcset;
        if (src) pre.src = src;
      }
    }
    pump();
  }
  function schedule() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preload, { timeout: 4000 });
    } else {
      window.setTimeout(preload, 1500);
    }
  }
  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule, { once: true });
  }
})();
